import { RecallPermissionKind } from "@/modules/electron/types";

export const DEFAULT_PERMISSION_STATUS_STATE: Record<RecallPermissionKind, boolean> = {
  [RecallPermissionKind.Microphone]: false,
  [RecallPermissionKind.Accessibility]: false,
  [RecallPermissionKind.ScreenCapture]: false,
  [RecallPermissionKind.SystemAudio]: false,
  [RecallPermissionKind.FullDiskAccess]: false,
};
